import { BaseResource } from '../core/base-resource';

export class Table extends BaseResource {
  label: string;

  constructor() {
    super();
  }

  deserialize(input: any): this {
    if (typeof input === 'string') {
      this.label = input;
      return this;
    }
    Object.assign(this, input);
    if (!this.label) {
      this.label = input.name || input.number || input.tableNumber || input.tableName || input.value || '';
    }
    return this;
  }
}
